import { render, staticRenderFns } from "./RelationListItem.vue?vue&type=template&id=2173347a&scoped=true"
import script from "./RelationListItem.vue?vue&type=script&lang=ts"
export * from "./RelationListItem.vue?vue&type=script&lang=ts"
import style0 from "./RelationListItem.vue?vue&type=style&index=0&id=2173347a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2173347a",
  null
  
)

export default component.exports